import request from '../request';
export const getFavorite = (axios, params) => {
  return request({
    url: '/v3/favorite_sample_cvs',
    method: 'get',
    data: params
  })
}
export const switchLike = (axios, params, token) => {
  return request({
    url: `/v3/favorite_sample_cvs/${token}`,
    method: 'put',
    data: params
  })
}
